export const ActionTypes = {
    SET_VIDEO_DURATION: 'SET_VIDEO_DURATION',
    SET_VIDEO_DIMENSIONS: 'SET_VIDEO_DIMENSIONS',
    SET_PLAYER_STATE: 'SET_PLAYER_STATE',
    SET_PLAYHEAD: 'SET_PLAYHEAD',
    SEEKING: 'SEEKING',
    PAUSE: 'PAUSE',
    SEEK_FROM_CONFIG: 'SEEK_FROM_CONFIG',
};

export const setVideoDuration = (duration) => ({
    type: ActionTypes.SET_VIDEO_DURATION,
    duration,
});

export const setVideoDimensions = (width, height) => ({
    type: ActionTypes.SET_VIDEO_DIMENSIONS,
    width,
    height,
});

export const setPlayerState = (state) => ({
    type: ActionTypes.SET_PLAYER_STATE,
    state,
});

export const setPlayhead = (currentTime) => ({
    type: ActionTypes.SET_PLAYHEAD,
    currentTime,
});

export const seek = (time) => (dispatch, getState, adapter) => {
    adapter.seek(time);
    dispatch({type: ActionTypes.SEEKING, time});
};

export const pause = () => (dispatch, getState, adapter) => {
    adapter.pause();
    dispatch({type: ActionTypes.PAUSE});
};

export const seekFromConfig = () => (dispatch, getState) => {
    const startTime = getState().config.get('startTime');
    if (startTime) {
        dispatch({type: ActionTypes.SEEK_FROM_CONFIG});
        dispatch(exports.seek(startTime));
    }
};



// WEBPACK FOOTER //
// ./scripts/store/video/actions.js